import user from './user'
import ui from './ui'
import gameplay from './gameplay'

export default [
    user,
    ui,
	gameplay,
]
